import React, { useState } from 'react'
import { Card, CardContent, Typography, Grid, Button, Box } from '@mui/material';
import { useTranslation } from "react-i18next";
import Modal from './Modal';
import { HomeSkeleton } from './HomeSkeleton';
export const CardUI = ({ temas }) => {
    const [open, setOpen] = useState(false);
    const [temaDialog, setTemaDialog] = useState(null);
    const { t } = useTranslation();

    const handleClickOpen = (temaDialog) => {
        setTemaDialog(temaDialog);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Box>
            <Grid container
                spacing={2}
            >
                {temas ? (
                    temas.map((tema, index) =>
                        <Grid item xs={12} sm={4} lg={4} key={index}>
                            <Card className='card' onClick={() => { handleClickOpen(tema) }}>
                                <CardContent>
                                    <img src={require("../../images/temas/"+tema.key+".png")} loading='lazy' alt={tema.key} />
                                    <Typography variant="h5" style={{ fontSize: '1.1em' }}>
                                        {tema.texto}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    )
                )
                    :
                    (
                        <HomeSkeleton />
                    )}
                {temaDialog && (
                    <Modal title={temaDialog.texto} content={temaDialog.descripcion} open={open} close={handleClose} >
                        <Button variant="contained" onClick={handleClose} >{t("general.aceptar")}</Button>
                    </Modal>
                )}
            </Grid >
        </Box>
    )
}